export default function About() {
  return (
    <section id="about" className="w-full bg-background-100/80 scroll-mt-16 py-12 md:py-16">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="grid gap-10 lg:grid-cols-2 lg:items-start">
          <div>
            <span className="inline-flex items-center gap-2 text-xs font-semibold text-primary-600">
              <i className="ri-information-line"></i>
              认识我们
            </span>
            <h2 className="mt-3 font-heading text-2xl md:text-4xl font-black text-foreground-950">关于吃瓜前线</h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-700">
              吃瓜前线是一个面向中文网络用户的热点跟进站，把散落在不同渠道的八卦与话题动态集中起来，按时间线整理成一份可以快速对齐的「进展台账」。
            </p>
            <p className="mt-3 text-sm leading-relaxed text-foreground-700">
              我们相信，真正有价值的不是转载本身，而是把事情讲清楚、把后续跟到位。无论是长线番位争议、品牌商务变动还是综艺现场的临时状况，你都可以在这里找到条理清晰的来龙去脉。
            </p>

            <h3 className="mt-6 font-heading text-base font-bold text-foreground-950">我们的内容原则</h3>
            <div className="mt-3 grid gap-3 sm:grid-cols-3">
              {[
                { icon: "ri-focus-3-line", title: "溯源", desc: "优先可查证信源" },
                { icon: "ri-flag-line", title: "标注", desc: "区分待证实与官回" },
                { icon: "ri-time-line", title: "跟更", desc: "进展不烂尾" },
              ].map((p) => (
                <div key={p.title} className="rounded-xl bg-background-50 border border-background-200 p-4">
                  <span className="w-9 h-9 flex items-center justify-center rounded-md bg-primary-500 text-background-50">
                    <i className={p.icon + " text-lg"}></i>
                  </span>
                  <h4 className="mt-3 text-sm font-semibold text-foreground-900">{p.title}</h4>
                  <p className="mt-1 text-xs text-foreground-600">{p.desc}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="space-y-5">
            <div className="rounded-2xl bg-foreground-950 text-background-50 p-6 md:p-7">
              <div className="flex items-center justify-between">
                <h3 className="font-heading text-lg font-bold">用户怎么说</h3>
                <span className="text-xs text-accent-400">站内口碑</span>
              </div>
              <div className="mt-4 space-y-4">
                {[
                  { name: "一只橙子", text: "一条瓜追了一个多星期，时间线排得清清楚楚，补课只要几分钟，太省事了。" },
                  { name: "晚风有信", text: "最怕断更，这边每条进展都标了跟进状态，官方回应也会单独标出来，理性很多。" },
                ].map((c) => (
                  <figure key={c.name} className="border-l-2 border-accent-500 pl-4">
                    <blockquote className="text-sm leading-relaxed text-background-100/90">“{c.text}”</blockquote>
                    <figcaption className="mt-2 text-xs text-background-300">— {c.name}</figcaption>
                  </figure>
                ))}
              </div>
            </div>

            <div className="rounded-2xl bg-background-50 border border-background-200 p-6 md:p-7">
              <h3 className="font-heading text-lg font-bold text-foreground-950">联系与合作</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">
                想爆料线索、指正信息，或洽谈栏目合作，欢迎来信，我们会认真查看每一条反馈。
              </p>
              <div className="mt-4 flex flex-wrap items-center gap-3">
                <a
                  href="mailto:hello@chigua-qianxian.example"
                  className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 text-background-50 px-4 py-2 text-sm hover:bg-primary-600 transition-colors"
                >
                  <i className="ri-mail-send-line"></i>
                  hello@chigua-qianxian.example
                </a>
                <span className="inline-flex items-center gap-2 text-sm text-foreground-500">
                  <i className="ri-community-line"></i>
                  站内反馈 · 理性交流
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}